import { useCallback } from 'react'
import { useClickOutside } from '@mantine/hooks'

/**
 * Close bottom refinement docks when the user taps/clicks the page behind them.
 * Mantine `Drawer` only honors `closeOnClickOutside` on the overlay; we use no overlay
 * so the guide stays scrollable (`lockScroll: false`).
 */
export function useRefinementDockClickOutside(
  opened: boolean,
  onClose: () => void
) {
  const handleClickOutside = useCallback(() => {
    if (opened) onClose()
  }, [opened, onClose])
  return useClickOutside(handleClickOutside)
}
